import { Controller } from "@hotwired/stimulus";

// 運用期間（予定）の値を運用期間（実績）の入力欄へコピーする
class CopyOperationPeriodController extends Controller {
  static targets = ['estimatedStart', 'estimatedEnd', 'actualStart', 'actualEnd']

  copy() {
    this.actualStartTarget.value = this.estimatedStartTarget.value
    this.actualEndTarget.value = this.estimatedEndTarget.value
  }
}

// Registered in admin.js
export { CopyOperationPeriodController };
